import { Fragment, useMemo, useState, useEffect } from "react";
import { BasicTable } from "../common/BasicTable";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../common/LoadingPage";
import ErrorPage from "../common/ErrorPage";
import { useCutoffSearchContext } from "../../store/CutoffSearchContextProvider";
import { CutoffFilterMap } from "./FilterComponents/FilterConstants";
//import FilterDown from "../../../assets/images/FilterDown.svg";
import { FilterButton } from "./SearchForm";
import { CutoffsMobileFirst } from "./CutoffsMobileFirst";
import { BaseColumns} from "./CutoffColumns";
import { PredictMatches } from "./PredictMatches";
import { checkApi } from "../../Authentication/AxiosInstance";

export const Cutoffs = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [includePWD, setIncludePWD] = useState(false);
  const [tableColumns, setTableColumns] = useState(null);
  const [tableData, setTableData] = useState(null);
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640); // 640px is the breakpoint used in CSS
    };

    // Check on mount
    checkMobile();
    
    // Listen for resize events
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  const filterMap = CutoffFilterMap;
  //console.log(filterMap)

  const searchObject = useCutoffSearchContext().cutoffSearchArray;
  //console.log(searchObject)
  
  const getSearchKey = (searchObject) => JSON.stringify(searchObject);
  //console.log(getSearchKey(searchObject));

  const searchArray = [searchObject];
  //console.log(searchArray);
  
  const fetchCutoffs = async () => {
    const searchParams = createSearchParams(searchArray);
    // Convert URLSearchParams to plain object for axios
    const params = Object.fromEntries(searchParams);
    
    const res = await checkApi.get('/capzone/cutoffs/',{params});
    return res.data;
  };

  const { data, error, status } = useQuery({
    queryKey: ["cutoffData", getSearchKey(searchObject)],
    queryFn: fetchCutoffs,
    enabled: !isMobile, // Only fetch when not on mobile (mobile component has its own query)
    throwOnError: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });
  console.log(status, error)

  // Get the columns for the table (use original data for column structure, filtered data for display)
  const baseColumns = useMemo(() => BaseColumns(data), [data]);
  
  // Initialize columns and data
  const columns = tableColumns || baseColumns; 
    

  function createSearchParams(params) {
    console.log(params);
    const searchParams = new URLSearchParams();
    params.forEach((item) => {
      Object.keys(item).forEach((paramKey) => {
        console.log(paramKey, item[paramKey]);
        
        if (item[paramKey]) {
          const findCutoffParent = filterMap.find((cutoffKey) => cutoffKey.parent === paramKey);
          console.log(findCutoffParent);
          const paramCutoffName = findCutoffParent ? findCutoffParent.cutoffs : null;
          console.log(paramCutoffName);
          if (paramCutoffName) {
            // max_round in defaults to get most recent round for JOSAA
            // replaced "=" with"" to avois encoding max_round with 3D= in query string"
            const suffix = paramCutoffName !== "max_round" ? "__icontains" : "";
            searchParams.append(paramCutoffName + suffix, item[paramKey]);
          }
        }
      });
    });
    console.log(searchParams.toString());
    return searchParams;
  }
  const ShowSearchCriteria = () => {
    return Object.entries(searchObject).map(([key, value]) => {
      console.log(key, value);
      if (value !== null) {
        return (
          <div key={key} className="flex">
            <label className="flex m-1 pr-2 w-full rounded border-2 border-cave-500 align-middle  ">
              <span className="m-1 text-secondary-900 text-sm font-bold">{value} &#x2713;</span>
            </label>
          </div>
        );
      }
    });
  };  
  
  // Filter data based on PWD checkbox
  const displayData = useMemo(() => {
    if (!data || data.length === 0) return [];
    if (includePWD) {
      return data.filter((item) => item.c001_common === "PWD");
    } else {
      return data.filter((item) => item.c001_common !== "PWD");
    }
  }, [data, includePWD]);

  // Use table data from PredictMatches or fallback to displayData
  const finalDisplayData = tableData || displayData;

  // Conditionally render based on screen size
  if (isMobile) {
    return <CutoffsMobileFirst />;
  }
  return (
    <Fragment>
      <div className="flex w-full px-4">
        {status === "pending" ? (
          <div className="flex w-full justify-center items-center">
            <LoadingPage invokedFrom="cutoffs" />
          </div>
        ) : status === "error" ? (
          <div className="w-full">
            (
              <ErrorPage 
              emessage={
                error?.response?.data?.detail || 
                error?.response?.data?.message || 
                error?.message || 
                "An error occurred while fetching cutoffs data"
              } 
              invokedFrom="cutoffs" 
            />
            )
            
          </div>
        ) : (
          <div className="w-full pr-4">
            <div className="flex flex-row space-x-4">
              <FilterButton className="w-1/3" optionType="cutoffs" />
              <div className="flex flex-col flex-1">
                <div className="flex flex-row justify-between items-center w-full h-8 ">
                  <div className="flex items-stretch">
                    {/* <img src={FilterDown} alt="FilterDown" className="flex h-8 m-0" /> */}
                    📌
                    <ShowSearchCriteria />
                  </div>
                </div>
                {displayData?.length > 0 ? (
                  <>
                  <div className="flex flex-row items-start">
                      <div className = "m-1 p-1 font-bold text-cave-900 text-base">Release Date: {displayData[0]?.c001_releasedate}</div>
                  </div>
                  <div id="commented code">
                  {/* Display PWD Only checkbox */}
                  {/* <div className="flex flex-row items-start">
                      <label className="m-1 p-1 font-bold text-cave-900 text-base flex items-center cursor-pointer">
                       Display PWD Only?
                          <input 
                            type="checkbox" 
                            className="m-2 w-4 h-4 cursor-pointer \
                            appearance-none hover:bg-primary-500 checked:bg-primary-500 accent-primary-500 border-2 border-primary-500 \
                            rounded-sm"
                            
                            checked={includePWD}
                            onChange={() => setIncludePWD(!includePWD)}
                          />
                         
                      </label>
                  </div> */}
                  {/* PredictMatches component */}
                  {/*
                  <PredictMatches
                    data={data}
                    displayData={displayData}
                    searchObject={searchObject}
                    baseColumns={baseColumns}
                    onDisplayDataChange={setTableData}
                    onColumnsChange={setTableColumns}
                  /> */}
                  </div>
                  <div className="flex flex-row space-x-4">
                    <BasicTable className="w-2/3" data={finalDisplayData} columns={columns} />
                  </div>
                  </>
                ):(
                    <ErrorPage nodatafound= {true} 
                    invokedFrom="cutoffs" 
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};
